import { ModalContent } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { StyledModal } from '@/styles.ts';

/*
 * ScaleUI's `ModalFooter` only renders action buttons, so the language selector is overlaid on the
 * empty left half of the footer. These mirror the footer's own hardcoded geometry — inline padding
 * 1.5rem, bottom padding 1rem, and a medium `Button` row 2.25rem tall — so the pill lines up with
 * the Close button rather than floating above or below it.
 */
const FOOTER_PADDING_INLINE = '1.5rem';
const FOOTER_PADDING_BOTTOM = '1rem';
const FOOTER_ACTION_ROW_HEIGHT = '2.25rem';

/** Positioning context for {@link StyledFooterLanguageSlot}; ScaleUI's modal element is static. */
export const StyledShortcutsModal = styled(StyledModal)`
  position: relative;
`;

export const StyledFooterLanguageSlot = styled.div`
  position: absolute;
  left: ${FOOTER_PADDING_INLINE};
  bottom: ${FOOTER_PADDING_BOTTOM};
  display: flex;
  align-items: center;
  height: ${FOOTER_ACTION_ROW_HEIGHT};
`;

export const StyledModalContent = styled(ModalContent)`
  padding-left: 0;
  padding-right: 0;
`;
